import { stringNormalize } from '../quill-marking-logic/src/libs/stringNormalize';

export default function() {
  return stringNormalize(this);
}
